"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/Carousel";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/Tabs";
import { LIFESTYLE_COMMUNITIES } from "@/enums/communitiy.enum";
import { useHashState } from "@/hooks/useHash";
import { useLocale, useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { ContentBlock } from "../Common/ContentBlock";
import { CommunityLifestyleCard } from "./Card";
import { COMMUNITIES_TABS, COMMUNITY_PROPERTY_OPTIONS } from "./constants";

export const CommunitiesSection = () => {
  const t = useTranslations("home.community");
  const [hash] = useHashState();
  const locale = useLocale() as "en" | "ar";

  const [selectedCommunity, setSelectedCommunity] = useState(
    LIFESTYLE_COMMUNITIES.WATER_AND_BEACH_FRONT
  );

  useEffect(() => {
    if (hash == "communities") {
      const communitiesSection = document.getElementById("communities");
      communitiesSection?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [hash]);

  return (
    <ContentBlock
      title={t("title")}
      variant="shadow"
      id="communities"
      titleElement={"h2"}
    >
      <div className="space-y-3 sm:space-y-6">
        <Tabs
          variant="underline"
          value={selectedCommunity}
          onValueChange={(value) =>
            setSelectedCommunity(value as LIFESTYLE_COMMUNITIES)
          }
        >
          <div className="overflow-x-auto">
            <TabsList>
              {COMMUNITIES_TABS.map((tab) => (
                <TabsTrigger value={tab.value} key={tab.value} className="px-4">
                  {t(`tabs.${tab.value}.title`)}
                </TabsTrigger>
              ))}
            </TabsList>
          </div>
        </Tabs>
        <Carousel>
          <CarouselContent>
            {COMMUNITY_PROPERTY_OPTIONS[selectedCommunity].map((community) => (
              <CarouselItem
                className="basis-3/4 sm:basis-1/4"
                key={community.key}
              >
                <CommunityLifestyleCard
                  image={community.image}
                  link={community.link[locale]}
                  location={t(
                    `tabs.${selectedCommunity}.cards.${community.key}.location`
                  )}
                  title={t(
                    `tabs.${selectedCommunity}.cards.${community.key}.title`
                  )}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </ContentBlock>
  );
};
